import Login from "../features/auth/screens/Login";
import ForgotPassword from "../features/auth/screens/ForgotPassword";
import AuthOTP from "../features/auth/screens/AuthOTP";
import ResetPassword from "../features/auth/screens/ResetPassword";

export const authRoutes = [
  { path: "login", element: <Login /> },
  { path: "forgot-password", element: <ForgotPassword /> },
  { path: "otp", element: <AuthOTP /> },
  { path: "reset-password", element: <ResetPassword /> },
  { path: "new-user", element: <AuthOTP /> },
];
